import { Component, ComponentFactoryResolver, ComponentRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, inject, DestroyRef } from '@angular/core';
import { EndpointType } from 'src/app/models/endpoint-type';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { UrlService } from 'src/app/services/util/url.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { ClipboardService } from 'ngx-clipboard';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import cloneDeep from 'lodash/cloneDeep';
import { translate } from '@jsverse/transloco';
import { SweetAlertService } from 'src/app/services/util/sweet-alert.service';
import { Constants } from 'src/app/models/constants';
import { ColumnFilterComponent } from 'src/app/main/instances-mgmt/column-filter/column-filter.component';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ChangeDetectorRef } from '@angular/core';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { GenericErrorComponent } from 'src/app/components/generic-error/generic-error.component';
import { DatePipe } from '@angular/common'
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { Permissions, Datazone, Attributes } from 'src/app/models/principal/permission';
import { CustomTooltipComponent } from 'src/app/main/custom-tooltip/custom-tooltip.component';
import { PopupHostDirective } from 'src/app/directives/host.directive';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, combineLatest, finalize, forkJoin, map, mergeMap, of } from 'rxjs';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { Solution } from 'src/app/models/service/solution';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { Blueprint, InstanceTabs } from 'src/app/models/blueprints/blueprint';
import { Instance } from 'src/app/models/instance/instance';
import { Configuration } from 'src/app/models/configurations/configuration';
import { DeploymentClass } from 'src/app/models/instance-class';
import { ConfigurationsService } from 'src/app/services/api/configurations.service';
import { ConfigurationApplicationStatus, ConfigurationPackageStatus,
  ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { Sort, SortDirection } from 'src/app/models/sort';
import { KeyValueMap } from 'src/app/models/key-value-map';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { isDate } from 'src/app/services/util/utils';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { NotificationsService } from 'src/app/services/api/notifications.service';
import { SolutionVersionsService } from 'src/app/services/util/solution-versions.service';
import { DateTimeService } from 'src/app/services/util/date-time.service';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { InstanceEnvironment } from 'src/app/models/instance-environment';
import { TimeDurationPipe } from 'src/app/pipes/timeDuration.pipe';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InstallationSpecificationService} from 'src/app/services/util/installation-specification.service';
import { CobService } from 'src/app/services/api/cob.service';
import cronstrue from 'cronstrue';
import { DurationPipe } from 'src/app/pipes/duration.pipe';
import { TestTypes } from 'src/app/models/instance/test-types';
import { InstallationSchemaPropertyType } from 'src/app/models/service/installation-schema-property-type';
import { BackupService } from 'src/app/services/api/backup.service';
import moment from 'moment';
import { InventoryService } from 'src/app/services/api/inventory.service';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { KubernetesResource } from 'src/app/models/kubernetes-resource';
import { DbbackupService } from 'src/app/services/api/dbbackup.service';
import { CapitalizeFirstPipe } from 'src/app/pipes/capitalize-first.pipe';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { SchedulerService } from 'src/app/services/api/scheduler.service';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { InstanceDetailsAddRouteComponent } from 'src/app/components/instance-details/instance-details-add-route/instance-details-add-route.component';
import { AddSshKeyComponent } from 'src/app/components/instance-details/add-ssh-key/add-ssh-key.component';
import { AddEncKeyComponent } from 'src/app/components/instance-details/add-enc-key/add-enc-key.component';
import { EnvironmentTableComponent } from '../environment-details/environment-table/environment-table.component';
import { EnvironmentPaginatorComponent } from '../environment-details/environment-paginator/environment-paginator.component';
import { AvailabilityStatus } from 'src/app/models/availability-status';
import { FeatureFlags } from 'src/app/models/constants/feature-flags.constant';

const REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_NONPII,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.NONPII
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_PII,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.PII
  },
  {
    key: PermissionKeys.INSTANCE_SFTP_CONFIG_DATAZONE_LIVE,
    action: Permissions.INSTANCE_SFTP_CONFIG,
    attribute: Attributes.DATAZONE,
    attributeValue: Datazone.LIVE
  }
];

@Component({
  selector: 'app-environment-sftp',
  templateUrl: './environment-sftp.component.html',
  styleUrl: './environment-sftp.component.scss',
  standalone: false,
 providers: [
        TimeDurationPipe,
        DurationPipe,
        CapitalizeFirstPipe
    ],
})


export class InstanceSftpComponent implements OnInit{
  @ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  @Input() data: any;
  @Input() serviceVersions: any;
  @Input() isLoading: any;
  @Input() instanceFeatureResponse: any;

  initialRouteData: any;
  sftpLoader = true;
  routeSearchTerm: string;
  keySearchTerm: string;
  filteredRouteData: any = [];
  sftpEncKeyRotation = false;
  private destroyRef = inject(DestroyRef);
  sftp: boolean;
  routeData: any;
  routes: any = [];
  keys: any = [];
  isFailed: boolean;
  pageIndex = 0;
  keyPageIndex = 0;
  sortInfo: any;
  paginationSize = 10;
  keyPaginationSize = 10;
  dataSource: any;
  addingStatus: boolean;
  direction: any;
  status: any;
  destinationType: any;
  service: Solution;
  instance: Instance;
  releaseVersion: any;
  isAMR: boolean;
  metricTimePieMonth:any;
  selectedMetricInstance: any;
  buildNumber: string;
  blueprint: Blueprint;
  istanceLoaded = false;
  routeExpandedElement: any;
  showActivityLoader = true;
  showSpinner: boolean;
  instanceId: any;
  searchTerm: string;
  PermissionKeys = PermissionKeys;
  Constants = Constants;
  initialEncKeys = [];
  encKeyLoader = true;
  encDropdownsList: any;
  encFilteredColumns: any;
  encFilterStartDate: any;
  encFilterEndDate: any;
  AvailabilityStatus = AvailabilityStatus;
   displayColumns = [
    {
      key: 'arrowClick',
      name: '',
      type: 'expand',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'routeName',
      name: 'INSTANCE_DETAILS.ROUTE_NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'routeId',
      name: 'INSTANCE_DETAILS.ROUTE_ID',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'direction',
      name: 'INSTANCE_DETAILS.DIRECTION',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'destinationType',
      name: 'ROUTE_FORM.DESTINATION_TYPE',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'encEnabled',
      name: 'INSTANCE_DETAILS.ENCRYPTION',
      type: 'text',
      sortable: false,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: 'INSTANCE_DETAILS.STATUS',
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'sftp',
      name: '',
      type: 'button',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'sftpSettings',
      name: '',
      type: 'settings'
    }
  ];
    encKeyDisplayColumns = [
     {
      key: 'name',
      name: 'INSTANCE_DETAILS.KEY_NAME',
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'publicKey',
      name: 'INSTANCE_DETAILS.KEY',
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'expirationDate',
      name: 'INSTANCE_DETAILS.EXPIRY_DATE_UTC',
      type: 'dateWithoutTime',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'status',
      name: 'INSTANCE_DETAILS.STATUS',
      type: 'status',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'sftpKeySettings',
      name: '',
      type: 'settings'
    }
  ];
  hasSecondaryRegion: any;
  expiryDateDropdownsList: any;
  dropdownsList: any;
  adoPipelineUrl: any;
  adoProjectName: any;
  searchedResult: any;
  encKeys: any;
  date: any;
  clearData: boolean;
  filteredColumns: any;
  DeployStatus = DeployStatus;
  permissionsMap: { [key: string]: boolean };
  currentTab = 0;
  searchedRouteResult: any;
  keyDisabledStatus = [DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.OPERATION_INPROGRESS,
      DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.STARTING,
      DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED, DeployStatus.INPROGRESS];


 readonly INSTANCE_DEPLOYING_STATES = [DeployStatus.DEPLOYING, DeployStatus.TERMINATED, DeployStatus.TERMINATION_FAILED,
    DeployStatus.CONFIGURING, DeployStatus.UPDATING, DeployStatus.OPERATION_INPROGRESS,
    DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING, DeployStatus.INITIALIZING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.TERMINATING, DeployStatus.TESTING, DeployStatus.STARTING, DeployStatus.STOPPING, DeployStatus.INPROGRESS];

 readonly routeButtonDisabledStatuses = [
    DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.TESTING,
    DeployStatus.OPERATION_INPROGRESS, DeployStatus.FAILED, DeployStatus.TERMINATED,
    DeployStatus.TERMINATING, DeployStatus.INITIALIZING, DeployStatus.INITIALIZED,
    DeployStatus.INITIALIZE_FAILED
  ];

  get isRouteButtonDisabled(): boolean {
    const isDisabled = this.routeButtonDisabledStatuses.includes(this.data?.status) || !this.sftp || this.sftpLoader || !this.addingStatus;
    return this.instance?.availabilityState
      ? this.instance.availabilityState !== AvailabilityStatus.RUNNING || isDisabled
      : isDisabled;
  }

  get isRouteButtonStatusDisabled(): boolean {
    return this.routeButtonDisabledStatuses.includes(this.data?.status) || !this.sftp;
  }

  constructor(private dateTimeService: DateTimeService, private authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorPageService: ErrorPageService,
    private blueprintsService: BlueprintsService,
    private configService: ConfigurationsService,
    private crvtService: CRVTService,
    private changeDetectorRef: ChangeDetectorRef,
    private notificationsService: NotificationsService,
    private solutionVersionsService: SolutionVersionsService,
    private timeDuration: TimeDurationPipe,
    private durationPipe: DurationPipe,
    private capitalizeFirst: CapitalizeFirstPipe,
    public urlService: UrlService, private toastrService: CustomToastrService, private clipboardApi: ClipboardService,public dateTimeFormatService: DateTimeFormatService,
     private instanceService: InstancesService, private sidenavService: SidenavService, private tenantService: TenantService,
      private dialog: MatDialog, private sweetAlertService: SweetAlertService, private toastrErrorService: ToastrErrorService, private cdr: ChangeDetectorRef,
      public datePipe: DatePipe, private permissionsService: PermissionsService, private componentFactoryResolver: ComponentFactoryResolver, private solutionsService: SolutionsService, private route: ActivatedRoute,
      private installationSpecificationService: InstallationSpecificationService,private formBuilder: FormBuilder, private cobService: CobService, private backupService: BackupService,
      public inventoryService: InventoryService,
      private featurePermissionsService: FeaturePermissionsService,private dbBackupService: DbbackupService, public schedulerService: SchedulerService) {

   }

  ngOnInit(): void {
    this.clearData = true;
    const date = [
      {value: 'Expiry Date', selected: false}
    ];
    this.expiryDateDropdownsList = [
      {
        title: 'Date',
        placeholder: 'Select Date',
        options: date
      }
    ];
    const directionOptions = [ {value: 'inbound' , selected: false},
    {value: 'outbound' , selected: false}
    ];
    const destinationTypeOptions = [ {value: 'artifactory' , selected: false},
    {value: 'fileshare' , selected: false}
    ];
    const statusOptions = [
      {value: 'adding' , selected: false, label: 'in progress'},
      {value: 'added' , selected: false, label: 'created'},
      {value: 'failed' , selected: false, label: 'failed'},
      {value: 'removing' , selected: false, label: 'removing'},
      {value: 'removed' , selected: false, label: 'removed'}
    ];
     this.dropdownsList = [
      {
        title: 'Direction',
        placeholder: 'Select Direction',
        options: directionOptions
      },
      {
        title: 'Status',
        placeholder: 'Select Status',
        options: statusOptions
      },
      {
        title: 'Destination Type',
        placeholder: 'Select Destination Type',
        options: destinationTypeOptions
      }
    ];

     if (localStorage.getItem('filteredEncKeyDate')) {
      const dateData = JSON.parse(localStorage.getItem('filteredEncKeyDate'));
      if (dateData) {
        this.date = dateData;
        this.expiryDateDropdownsList[0].options.forEach(element => {
          if(dateData.find(item=> item === element.value)) {
            element.selected = true;
          }
        });
      }
    }
    this.encFilterStartDate = localStorage.getItem('filteredEncKeyStartDate') ? localStorage.getItem('filteredEncKeyStartDate'): '';
    this.encFilterEndDate = localStorage.getItem('filteredEncKeyEndDate') ? localStorage.getItem('filteredEncKeyEndDate'): '';
    this.routeData = [];
    this.loadData(this.routeData);
   this.permissionsMap = this.permissionsService.resolveAPIPermissions(REQUIRED_PERMISSIONS);
   this.getTenantDetails();
   this.initialLoad();
   this.getEncKeys();
   this.loadRoutesWithKeyExpiration();

  }

    createEncKey() {
      if (this.keyDisabledStatus.find(item=> item === this.data.status) || this.INSTANCE_DEPLOYING_STATES.includes(this.data?.status) || !this.sftp) {
        this.dialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
      } else {
        const data = {
          id: this.data.id
        };
        this.sidenavService.openInRightSidenav(AddEncKeyComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data) => {
          if (!data) {
            return;
          } else {
            this.getEncKeys();
          }
        });
      }
    }

    closeMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

    filteredColumnsFunction(data): void {
    if(this.direction === data) {
      this.direction = undefined;
      this.dropdownsList[0]?.options?.forEach(element => {
        element.selected = false;
      });
    } else if(this.status === data) {
      this.status = undefined;
      this.dropdownsList[1]?.options?.forEach(element => {
        element.selected = false;
      });
    } else if (this.destinationType === data) {
      this.destinationType = undefined;
      this.dropdownsList[2]?.options?.forEach(element => {
        element.selected = false;
      });
    }
    this.filterSftpData();
  }


    cancelScheduleDateFilter() {
    this.encFilterStartDate = undefined;
    this.encFilterEndDate = undefined;
    this.expiryDateDropdownsList[0].options[0].selected = false;
    this.date?.forEach(element => {
      if(element.includes(this.expiryDateDropdownsList[0].options[0].value)) {
        this.date.pop(element);
      }
    });
    localStorage.removeItem('filteredEncKeyStartDate');
    localStorage.removeItem('filteredEncKeyEndDate');
    localStorage.removeItem('filteredEncKeyDate');
    this.filterScheduleItems(this.filteredColumns);
  }

  getEncKeys(): void {
    this.instanceService.getEncryptionKeys(this.activatedRoute.snapshot.params.instanceId).pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((result: any) => {
      if (result && result.length > 0) {
        result.forEach(element => {
          element.publicKey = atob(element.publicKey);
        });
        const filteredRecords = this.filterHighestVersionRecords(result);
        this.initialEncKeys = filteredRecords;
        this.encKeys = filteredRecords;
        this.initialEncKeyFilterItems();
      }
      this.encKeyLoader = false;
    }, (error) => {
      this.encKeyLoader = false;
      this.initialEncKeyFilterItems();
        setTimeout(() => {
		      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
    });
  }

  /**
 * Method to be called to apply the initial filter from localstorage
 */
initialEncKeyFilterItems() {
  this.encKeys = this.initialEncKeys;
      if (this.expiryDateDropdownsList[0]?.options[0]?.selected && this.encFilterStartDate && this.encFilterEndDate) {
        this.encKeys = this.encKeys?.filter(item => this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') >= this.datePipe.transform(this.encFilterStartDate, 'yyyy-MM-dd') &&
          this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') <= this.datePipe.transform(this.encFilterEndDate, 'yyyy-MM-dd'));
      }
}


    /**
   * Filters encKey data based on a version for same key name.
   */
  filterHighestVersionRecords(records: any[]) {
    if(records.length > 0){
    const maxVersions = records.reduce((acc, record) => {
      const name = record.name;
      const version = Number(record.version);
      if (!acc[name] || version > acc[name]) {
        acc[name] = version;
      }
      return acc;
    }, {});
    return records.filter(record => {
      const version = Number(record.version);
      const maxVersionForName = maxVersions[record.name];
      return version === maxVersionForName;
    });
  }
  }

    resetFilter(): void {
      this.destinationType = undefined;
    this.direction = undefined;
    this.status = undefined;
    this.clearData = false;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.filterSftpData();
  }

    resetAllValues(): void {
     this.dropdownsList.forEach(element => {
      element?.options?.forEach(item => {
        item.selected = false;
      });
    });
  }

   keyFilterColumns(): void {
      if(this.date) {
        this.expiryDateDropdownsList[0].options.filter((item) => {
          if (item.value === this.date) {
            item.selected = true;
          }
        });
      }
      const data = {
        name: translate('SCHEDULES.SCHEDULE_FILTERS'),
        title: translate('INSTANCE_STATUS.FILTER_TITLE'),
        subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
        filteredColumns: this.expiryDateDropdownsList,
        scheduleDate: this.expiryDateDropdownsList[0].options,
        scheduleStartDate: this.expiryDateDropdownsList[0].options[0]?.selected ? moment(this.encFilterStartDate) : '',
        scheduleEndDate: this.expiryDateDropdownsList[0].options[0]?.selected ? moment(this.encFilterEndDate) : '',
        scheduleColumns: [
          'date'
        ]
      };
      this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        this.filteredColumns = filteredColumns;
        if (filteredColumns) {
          if(filteredColumns[2] !== '') {
            localStorage.removeItem('filteredEncKeyDate');
            this.date = filteredColumns[2];
            localStorage.setItem('filteredEncKeyDate', JSON.stringify(filteredColumns[2]));
          }
          if (filteredColumns[2]?.length === 0){
            this.resetScheduleFilter();
          } else {
            this.filterScheduleItems(filteredColumns);
          }
        }
      });
    }

      filterScheduleItems(filteredColumns): void {
        if (filteredColumns) {
          this.encKeys = this.initialEncKeys;

          if (this.expiryDateDropdownsList[0].options[0].selected && moment(filteredColumns[3].filteredStartDate).isValid() && moment(filteredColumns[3].filteredEndDate).isValid()) {
            this.encFilterStartDate = filteredColumns[3].filteredStartDate;
            this.encFilterEndDate = filteredColumns[3].filteredEndDate;
            localStorage.setItem('filteredEncKeyStartDate', this.encFilterStartDate);
            localStorage.setItem('filteredEncKeyEndDate', this.encFilterEndDate);
            this.encKeys = this.encKeys?.filter(item => this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') >= this.datePipe.transform(this.encFilterStartDate, 'yyyy-MM-dd') &&
              this.datePipe.transform(item.expirationDate, 'yyyy-MM-dd') <= this.datePipe.transform(this.encFilterEndDate, 'yyyy-MM-dd'));
          } else {
            this.encFilterStartDate = undefined;
            this.encFilterEndDate = undefined;
            localStorage.removeItem('filteredEncKeyStartDate');
            localStorage.removeItem('filteredEncKeyEndDate');
          }
        }
      }

    resetScheduleFilter(): void {
    this.expiryDateDropdownsList[0].options.filter((item) => {item.selected = false});
    this.date = undefined;
    this.encFilterStartDate = undefined;
    this.encFilterEndDate = undefined;
    this.encKeys = this.initialEncKeys;
    localStorage.removeItem('filteredEncKeyDate');
    localStorage.removeItem('filteredEncKeyStartDate');
    localStorage.removeItem('filteredEncKeyEndDate');
  }


   getTenantDetails() {
     this.tenantService.getTenantDetails(this.data?.tenantId)
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe((data: any) => {
       if(data?.parameters?.hasSecondaryRegion && (data?.parameters?.hasSecondaryRegion === 'true' || data?.parameters?.hasSecondaryRegion === true)) {
          this.hasSecondaryRegion = true;
        } else if(!data?.parameters?.hasSecondaryRegion) {
          this.hasSecondaryRegion = true;
        } else {
          this.hasSecondaryRegion = false;
        }
    if(data?.sharedServices?.pii?.sftpEncKeyRotation && (data?.sharedServices?.pii?.sftpEncKeyRotation === true || data?.sharedServices?.pii?.sftpEncKeyRotation === 'true')) {
        this.sftpEncKeyRotation = true;
      } else {
        this.sftpEncKeyRotation = false;
      }
      this.data.managementType = data.managementType;
      this.adoPipelineUrl = data?.adoPipelineUrl;
      this.adoProjectName = data?.adoProjectName;
    });
}
   openRouteDetails(loggedResponse): any {
      this.instanceService.getInstanceDetailsSftpDetailsByIdByRouteID(this.data.id, loggedResponse.routeId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(loggedData => {
          this.sidenavService.openInRightSidenav(InstanceDetailsAddRouteComponent, { loggedData, edit: true });
        });
    }

  /**
   * Filters route data based on a search term entered by the user.
   */
    searchRoute(searchTerm?: string): void {
      this.routeSearchTerm = searchTerm?.trim().toLowerCase() || '';

    // if (!this.routeSearchTerm) {
    //   this.filteredRouteData = [...this.initialRouteData];
    // } else {
    //   this.filteredRouteData = this.initialRouteData.filter(route =>
    //     route.routeName?.toLowerCase().includes(this.routeSearchTerm) ||
    //     route.routeId?.toLowerCase().includes(this.routeSearchTerm) ||
    //     route.direction?.toLowerCase().includes(this.routeSearchTerm) ||
    //     route.status?.toLowerCase().includes(this.routeSearchTerm)
    //   );
    // }
  }

  searchedItems(result): void {
    this.searchedResult = result;
  }
  searchedRouteItems(result): void {
    this.searchedRouteResult = result;
  }

    createRoutes(): any {
       if (!this.addingStatus || this.isRouteButtonDisabled) return;
      const disabledStatus = [DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.OPERATION_INPROGRESS,
        DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.STARTING,
        DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED, DeployStatus.INPROGRESS];
      if (disabledStatus.find(item=> item === this.data.status) || !this.sftp) {
        this.dialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
      } else {
        setTimeout(() => {
          if (document.getElementsByClassName("cdk-overlay-container")) {
            const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
            if (element) {
              element.style.display = 'block';
            }
          }
        }, 100);
        const isArtifactoryFeature = this.instanceFeatureResponse?.some(
          (flag: any) => flag.id === FeatureFlags.SFTP_ARTIFACTORY_DESTINATION && (flag.enabled === true || flag.enabled === 'true')
        ) ?? false;
        const data = {
          id: this.data.id,
          sftpEncKeyRotation: this.sftpEncKeyRotation,
          isArtifactoryFeature: isArtifactoryFeature
        };
          this.sidenavService.openInRightSidenav(InstanceDetailsAddRouteComponent, data)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((formData) => {
            if (!formData) {
              return;
            } else {
              this.routeData = formData;
              this.initialLoad();
              this.loadRoutesWithKeyExpiration();
            }
          });
      }
    }

    editRoute(editData): any {
      const disabledStatus = [DeployStatus.TERMINATION_FAILED, DeployStatus.DEPLOYING, DeployStatus.OPERATION_INPROGRESS,
        DeployStatus.FAILED, DeployStatus.TERMINATED, DeployStatus.TERMINATING, DeployStatus.STARTING,
        DeployStatus.STOPPED, DeployStatus.STOPPING, DeployStatus.START_FAILED, DeployStatus.INPROGRESS];
      if (disabledStatus.find(item=> item === this.data.status) || !this.sftp) {
        this.dialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
      } else {
        const data = {
          id: this.data.id,
          sftpEncKeyRotation: this.sftpEncKeyRotation,
          edit: true,
          editData
        };
        this.sidenavService.openInRightSidenav(InstanceDetailsAddRouteComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((formData) => {
          if (!formData) {
            return;
          } else {
            this.routeData = formData;
              setTimeout(() => {
                const title = translate('TENANT_DETAILS.SFTP');
                const message = translate('INSTANCE_DETAILS.EDIT_ROUTES');
                this.toastrService.successMessage(message, title);
              }, 500);
            this.initialLoad();
            this.loadRoutesWithKeyExpiration();
          }
        });
      }
    }

    deleteRoute(data): any {
      if(data.status !== 'adding') {
        if(data.status !== 'removed') {
          if(data.status !== 'removing') {
          this.dialog.open(ConfirmationDialogComponent, {
            panelClass: 'default-dialog-wrapper',
            width: '566px',
            autoFocus: false,
            data: {
              title: translate('INSTANCE_DETAILS.TITLE'),
              message: translate('INSTANCE_DETAILS.MESSAGE'),
              confirmButtonText: translate('BUTTONS.DELETE')
            }
          })
            .afterClosed()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(confirm => {
              if (confirm) {
                this.instanceService.deleteInstanceDetailsSftpRoute(this.data.id, data.routeId)
                  .pipe(
                    takeUntilDestroyed(this.destroyRef))
                  .subscribe((res) => {
                    if (res) {
                      this.routeData = res;
                      setTimeout(() => {
                       const title = translate('TENANT_DETAILS.SFTP');
                       const message = translate('INSTANCE_DETAILS.DELETE_ROUTE');
                        this.toastrService.successMessage(message, title);
                      }, 500);
                      this.initialLoad();
                    }
                  },
            (error) => {
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('ERROR_DIALOG.DELETE_SFTP_FAILED'),
                description: errorMessage
              }
            });
          });
              }
            },
            (error) => {
              const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '342px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('ERROR_DIALOG.DELETE_ROUTE_NOT_AVAILABLE'),
                description: errorMessage
              }
            });
          });
        }
      }
      } else {
        return false;
      }
    }

      /**
 * Loads route details and their corresponding encryption name & expiration dates.
 * This method uses `forkJoin` to parallelly fetch:
 *  - Route details for the current instance (`getInstanceDetailsSftpDetailsById`)
 *  - Encryption keys for the instance (`getEncryptionKeys`)
 */
  loadRoutesWithKeyExpiration(): void {
  forkJoin({
  routesResult: this.instanceService.getInstanceDetailsSftpDetailsById(this.activatedRoute.snapshot.params.instanceId),
  keysResult: this.instanceService.getEncryptionKeys(this.activatedRoute.snapshot.params.instanceId)
}).subscribe({
  next: ({ routesResult, keysResult }) => {
    this.keys = keysResult;
    this.routes = routesResult.map(route => {
      const matchedKey = this.keys.find(key => key.name === route.encKeyName);
      const formattedDate = this.dateTimeService.formatToShortDate(matchedKey?.expirationDate);
      return {
        ...route,
        encKeyName: route.encKeyName,
        encKeyExpirationDate: formattedDate
      };
    });
  },
});
}

 loadData(data): void {
    this.pageIndex = 0;
    if (this.sortInfo) {
      const sortedData = this.sortInstanceData(this.sortInfo);
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    } else {
      const sortedData =  this.sortInstanceData({active: 'status', direction: 'asc'});
      this.dataSource = new MatTableDataSource(sortedData?.data?.slice(this.pageIndex, this.paginationSize));
    }
    this.addingStatus = true;
    if(this.initialRouteData) {
      this.initialRouteData.forEach(element => {
      if(element?.status === 'adding') {
        this.addingStatus = false;
      }
    });
    }
  }

    pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      const data = this.routeData.slice(firstIndex, firstIndex + this.paginationSize);
      this.dataSource = new MatTableDataSource(data);
    }
  }

    /**
     * This method calls when a user need to edit the enc keys.
     * @param value would be the selected key data.
     */
    editKeyRoute(value): void {
      const data = {
        id: this.activatedRoute.snapshot.params.instanceId,
        edit: true,
        value
      };
      this.sidenavService.openInRightSidenav(AddEncKeyComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (!data) {
          return;
        } else {
          this.getEncKeys();
        }
      });
    }

    filterColumns(): void {
        if(this.direction) {
          this.dropdownsList[0].options.filter((item) => {
            if (item.value === this.direction) {
              item.selected = true;
            }
          });
        } else {
          this.dropdownsList[0].options.filter((item) => {
            item.selected = false;
          });
        }
        if(this.status) {
          this.dropdownsList[1].options.filter((item) => {
            if (item.value === this.status) {
              item.selected = true;
            }
          });
        } else {
          this.dropdownsList[1].options.filter((item) => {
            item.selected = false;
          });
        }
        if(this.destinationType) {
          this.dropdownsList[2].options.filter((item) => {
            if (item.value === this.destinationType) {
              item.selected = true;
            }
          });
        } else {
          this.dropdownsList[2].options.filter((item) => {
            item.selected = false;
          });
        }
        const data = {
          name: translate('INSTANCE_STATUS.ROUTE'),
          title: translate('INSTANCE_STATUS.FILTER_TITLE'),
          subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
          filteredColumns: this.dropdownsList,
          direction: this.dropdownsList[0].options,
          status: this.dropdownsList[1].options,
          destinationType: this.dropdownsList[2].options
        };
        this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(filteredColumns => {
              if (filteredColumns) {
                this.clearData = true;
                if(filteredColumns[0] !== '') {
                  this.direction = filteredColumns[0];
                }
                if(filteredColumns[1] !== '') {
                  this.status = filteredColumns[1];
                }
                if(filteredColumns[2] !== '') {
                  this.destinationType = filteredColumns[2];
                }
                this.filterSftpData();
              }
            });
      }

    sortInstanceData(event): any {
    return this.routeData?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'routeId':
          comparatorResult = a?.routeId && b?.routeId ? a?.routeId?.localeCompare(b?.routeId) : !a?.routeId ? -1 : 1;
          break;
        case 'routeName':
          comparatorResult = a?.routeName && b?.routeName ? a?.routeName?.localeCompare(b?.routeName) : !a?.routeName ? -1 : 1;
          break;
        case 'direction':
          comparatorResult = a?.direction && b?.direction ? a?.direction?.localeCompare(b?.direction) : !a?.direction ? -1 : 1;
          break;
        case 'destinationType':
          comparatorResult = a?.destinationType && b?.destinationType ? a?.destinationType?.localeCompare(b?.destinationType) : !a?.destinationType ? -1 : 1;
          break;
        case 'status':
          comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status)
            : !a?.status ? -1 : 1;
          break;
        default:
          comparatorResult = a?.status && b?.status ? a?.status?.localeCompare(b?.status) : !a?.status ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }


  initialLoad(): void {
    this.sftpLoader = true;
    this.isFailed = false;
    this.routeData = [];
    this.loadData(this.routeData);
    if(this.direction) {
      localStorage.setItem('filteredDirection', this.direction);
      } else {
        localStorage.removeItem('filteredDirection');
      }
    if(this.status) {
      localStorage.setItem('filteredSftpStatus', this.status);
    } else {
      localStorage.removeItem('filteredSftpStatus');
    }
    if(this.destinationType) {
      localStorage.setItem('filteredDestinationType', this.destinationType);
    } else {
      localStorage.removeItem('filteredDestinationType');
    }
    if(this.data?.name === 'Demo Instance') {
      this.sftp = false;
    } else {
      this.sftp = true;
    }
    this.instanceService.getInstanceDetailsSftpDetailsById(this.activatedRoute.snapshot.params.instanceId, this.direction ? this.direction : undefined, this.status ? this.status : undefined)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.sftpLoader = false;
        this.isFailed = true;
        if (this.keys && this.keys.length > 0) {
          data = data.map((route) => {
            const matchedKey = this.keys.find(
              (key) => key.name === route.encKeyName
            );
            const formattedDate = this.dateTimeService.formatToShortDate(
              matchedKey?.expirationDate
            );
            return {
              ...route,
              encKeyName: route.encKeyName,
              encKeyExpirationDate: formattedDate,
            };
          });
        }
        this.initialRouteData = data;
        this.filterSftpData();
      },
      (error) => {
        this.sftpLoader = false;
        this.isFailed = true;
        setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
      this.loadService();
  }

    filterSftpData(): void {
    this.routeData = this.initialRouteData;
    if (this.status) {
      this.routeData = this.routeData.filter(item => item.status === this.status);
      localStorage.setItem('filteredSftpStatus', this.status);
    } else {
      localStorage.removeItem('filteredSftpStatus');
    }
    if (this.direction) {
      this.routeData = this.routeData.filter(item => item.direction === this.direction);
      localStorage.setItem('filteredDirection', this.direction);
    } else {
      localStorage.removeItem('filteredDirection');
    }
    if (this.destinationType) {
      this.routeData = this.routeData.filter(item => item.destinationType === this.destinationType);
      localStorage.setItem('filteredDestinationType', this.destinationType);
    } else {
      localStorage.removeItem('filteredDestinationType');
    }
    this.loadData(this.routeData);
    this.filteredRouteData = [...this.routeData];
  }

    // Gets solution details based on service id and adds in breadcrumbs
  private loadService(): void {
    const serviceId = this.data?.solutionId;
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId), this.solutionsService.getSolutionVersions(serviceId)])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([service, serviceVersions]) => {
        this.service = service;
        this.serviceVersions = serviceVersions;
        this.loadInstances();
      }, (error) => {
         setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
      });
  }

   // Gets instance details based on instance id and sets build number by matching id with service version
  private loadInstances(): void {
    const instanceId = this.activatedRoute.snapshot.params.instanceId;
    this.instanceService.getInstancesForSolution(this.service.id, undefined, this.data.tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        this.instance = instances?.data?.find(item => item.id === instanceId);
        // if (this.instance?.status === DeployStatus.TERMINATING || this.instance?.status === DeployStatus.TERMINATED) {
        //   this.errorPageService.show404Page();
        // }
        this.releaseVersion = this.serviceVersions.find(version => version.id === this.instance?.solutionVersionId)?.releaseVersion;
        if(this.releaseVersion && this.solutionVersionsService.releaseVersion(this.releaseVersion)) {
          this.isAMR = true;
        }
        this.buildNumber = this.serviceVersions.find(version => version.id === this.instance?.solutionVersionId)?.version;
        this.loadBlueprint();
        const now = new Date();
        const currentYearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
      //  this.loadUsageSummary(instanceId, currentYearMonth);
        this.metricTimePieMonth = currentYearMonth;
        this.selectedMetricInstance = instanceId;
      }, (err) => this.errorPageService.show404Page());
  }

    private loadBlueprint(): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    this.blueprintsService.getBlueprints()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(blueprint => {
        this.blueprint = blueprint.find(item => item.id === blueprintId);
        if (this.instance?.deploymentClass === DeploymentClass.D) {
          this.instance.environment = 'DEV';
        } else {
          if (this.instance?.environment) {
            this.instance.environment = this.blueprint?.pathToLiveConfiguration
            .find(item => item?.instanceId === this.instance?.id)?.environment;
          }
        }
        this.istanceLoaded = true;
      //  this.loadReleaseData(true);
      }, (err) => this.errorPageService.show404Page());
  }

    openSshKeyForm(routeData): void {
      if (routeData?.status === 'added' || routeData?.status === 'updated') {
        this.routeExpandedElement = null;
        this.dataSource?.filteredData?.forEach(data => data.arrowClick = false);
        setTimeout(() => {
          if (document.getElementsByClassName("cdk-overlay-container")) {
            const element = <HTMLElement> document.getElementsByClassName("cdk-overlay-container")[0];
            if (element) {
              element.style.display = 'block';
            }
          }
        }, 100);
        const instanceId = this.activatedRoute.snapshot.params.instanceId;
        const data = {
          routeData,
          instanceId
        };
        this.sidenavService.openInRightSidenav(AddSshKeyComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(changed => {
          if (changed) {
            this.sftpLoader = true;
            this.isFailed = false;
            this.routeData = [];
            this.loadData(this.routeData);
            this.filteredRouteData = [...this.routeData];
            this.instanceService.getInstanceDetailsSftpDetailsById(this.data.id, this.direction ? this.direction : undefined, this.status ? this.status : undefined)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(data => {
              this.sftpLoader = false;
              this.isFailed = true;
              this.routeData = data;
              this.loadData(this.routeData);
              this.filteredRouteData = [...this.routeData];
            },
            (error) => {
              this.sftpLoader = false;
              this.isFailed = true;
          setTimeout(() => {
            const title = translate('ERRORS.SERVICE_AVAILABILITY');
            const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
            this.toastrService.errMessage(message, title);
          }, 500);
            });
          }
        });
      } else {
        this.dialog.open(GenericErrorComponent, {
          minHeight: '342px',
          width: '566px',
          panelClass: 'flex-dialog'
        });
      }
    }

   viewSshKeys(routeExpandedElement): void {
    const data = {
      routeData: routeExpandedElement,
      viewKeys: true
    };
    this.sidenavService.openInRightSidenav(AddSshKeyComponent, data);
  }

   /**
 * Filters encKey data based on a search term entered by the user.
 */
searchEncKey(searchTerm?: string): void {
  this.searchTerm = searchTerm;
}

// refreshing route table on refresh icon click
  refreshClick(): void {
    this.initialLoad();
    this.loadRoutesWithKeyExpiration();
  }

  // on page changed from header paginator changing the table paginator as well
  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

  // on page changed from table paginator changing the header paginator as well
   onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }

  // resetting header paginator on sorting
  resetPaginator() {
    this.pageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }

  // assigning current tab when tab is changed
  onIndexChange(event): void {
    this.currentTab = event;
    if (event !== 0) {
      this.routeSearchTerm = '';
      this.filterSftpData();
    }
    // Clear search and filters when switching away from keys tab
    if (event !== 1) {
      this.searchTerm = '';
      this.initialEncKeyFilterItems();
    }
  }

  // on key page changed from header paginator changing the table paginator as well
  onKeyPageChange(event) {
    this.keyPaginationSize = event.pageSize;
    this.keyPageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

  // on key page changed from table paginator changing the header paginator as well
   onKeyTablePageChanged(event) {
    this.keyPageIndex = event.pageIndex;
    this.keyPaginationSize = event.pageSize;
  }

  // resetting header paginator on sorting for key table
  resetKeyPaginator() {
    this.keyPageIndex = 0;
    this.paginatorRef.pageIndex = 0;
  }

  // refreshing keys table on refresh icon click
  keyRefreshClick() {
    this.encKeyLoader = true;
    this.getEncKeys();
  }

  get statusLabel(): string {
    return this.dropdownsList?.[1].options.find(option => option.value === this.status)?.label ?? this.status;
  }

}
